import { RefObject, useEffect } from "react"

export function useVisibility(
  ref: RefObject<HTMLElement>,
  callback: () => void
) {
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 1) {
          // Item is fully in view
          observer.disconnect()
          callback()
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      }
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => observer.disconnect()
  }, [])
}